﻿export const siteSettings = { ...window.siteSettings };